import React, { useRef, useState, useEffect } from 'react';
import Button from '@material-ui/core/Button';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import CommentIcon from '@mui/icons-material/Comment';
import moment from 'moment';

import IconButton from '@material-ui/core/IconButton';
import DeleteIcon from '@mui/icons-material/Delete';

//alerta
import { toast } from 'react-toastify';
import ConfirmDialog from '../../components/Notification/ConfirmDialog';

import './styles.css';
import api from '../../services/api';
import { toBase64 } from '../utils/toBase64';
import { Grid, Link, SnackbarContent } from '@mui/material';
import { AttachFile, Download } from '@mui/icons-material';

//estilo
const classes = {
  root: {
    width: '100%'
  },

  rootCidadao: {
    width: '100%'
  },

  area: {
    width: '100%',
  },

  /* Estilização do conteúdo dentro do container */
  paper: {
    padding: 16,
    display: 'flex',
    overflow: 'auto',
    flexDirection: 'row',
    width: '100%',
    backgroundColor: '#F5F5F5',
  },

  textTitle: {
    margin: 8,
    color: '#41414d',
    fontWeight: 600,
  },

  textDescription: {
    padding: 10,
    backgroundColor: '#FFFBE8',
    color: 'rgba(0,0,0,0.8)',
    borderRadius: 7,
    width: '100%',
    fontFamily: 'Rawline',
    marginBottom: 20
  },

  comment: {
    padding: 10,
    color: 'rgba(0,0,0,0.8)',
    borderRadius: 7,
    width: '100%',
    fontFamily: 'Rawline',
    marginBottom: 20
  },

  areaDescription: {
    margin: 1,
  },
  userComment: {
    color: '#41414d',
    fontSize: 14,
  },

  textComment: {
    marginTop: 1,
    color: 'rgba(0, 0, 0, 0.54)',
    marginBottom: 1
  },

  textDelete: {
    marginTop: 2,
    color: 'rgba(245, 0, 87, 0.55)',

  },

  buttonSubmit: {
    backgroundColor: '#1551B3',
    color: '#fff',
    borderRadius: '20px',
    height: '45px',
    textTransform: 'capitalize',
    fontWeight: 'bold',
    fontSize: 15,
    marginTop: '17px',
    minWidth: '220px'
  },

  attachButton: {
    backgroundColor: '#1551B3',
    color: '#fff',
    borderRadius: '20px',
    height: '45px',
    textTransform: 'capitalize',
    fontWeight: 'bold',
    fontSize: 15,
    marginTop: '17px'
  },

  downloadButton: {
    borderRadius: '50%',
    backgroundColor: '#1551B3',
    color: '#fff',
    width: 40,
    height: 40,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  }

};

export default function ComentComplaint({ id_complaint, userPermission, comment, cod_complaint, onCommentAdded, controladorName }) {
  const [commentSend, setCommentSend] = useState('');
  const fileInputRef = useRef(null);

  const [documentBase64, setDocumentBase64] = useState();
  const [documentName, setDocumentName] = useState();
  const [documentType, setDocumentType] = useState();

  const [localComments, setLocalComments] = useState(comment || []);

  useEffect(() => {
    setLocalComments(comment || []);
  }, [comment]);

  async function refreshComments() {
    const complaintId = window.location.pathname.split('/').pop();
   
      await new Promise(resolve => setTimeout(resolve, 5000));
      try {
        let response;
        if (userPermission === 'manager' || userPermission === 'executor') {
          response = await api.get(`${userPermission}/complaints/${complaintId}/coments`);
        } else {
          response = await api.get(`${userPermission}/coments?filter={"where":{"complaintId":"${complaintId}"}}`);
        }
        setLocalComments(response.data);
        if (onCommentAdded) onCommentAdded();
        return;
      } catch (err) {

      }
    
  }

  //alerta
  const [confirmDialog, setConfirmDialog] = useState({ isOpen: false, title: '', subTitle: '' })


  //Chama o alerta para cadastrar
  function confirms(e) {
    e.preventDefault();

    setConfirmDialog({
      isOpen: true,
      title: `Você está enviando um parecer, deseja confirmar?`,
      subTitle: ``,
      onConfirm: () => {
        handleComment();
      }
    })
  }

  // Registrar um parecer
  async function handleComment() {
    const id_complaint = window.location.pathname.split("/").pop();
    const id_user = localStorage.getItem('IdUser');

    const data = {
      "userId": id_user,
      "type": userPermission,
      "description": commentSend,
      "complaintId": id_complaint,
      "documents": []
    };

    if (documentBase64) {
      data.documents.push({
        "type": documentType,
        "blob": documentBase64
      })
    }

    try {
      await api.post(`${userPermission}/complaints/${id_complaint}/coments`, data);

      // O parecer já foi cadastrado com sucesso: limpa o rascunho e dá feedback
      // antes de qualquer efeito colateral (assume/reload).
      localStorage.removeItem(id_complaint + "_comment");
      localStorage.removeItem(id_complaint + "_document");
      localStorage.removeItem(id_complaint + "_document_name");
      localStorage.removeItem(id_complaint + "_document_type");

      setCommentSend('');
      setDocumentBase64(undefined);
      setDocumentName(undefined);
      setDocumentType(undefined);

      toast.success('Parecer cadastrado com sucesso.');

      setConfirmDialog({ ...confirmDialog, isOpen: false });

      if (userPermission === 'manager' && !controladorName) {
        // Assume a ocorrência automaticamente. Uma falha aqui não deve
        // sinalizar erro no parecer, que já foi salvo com sucesso.
        try {
          await api.put(`${userPermission}/complaints/${id_complaint}/assume`);
        } catch (assumeErr) {
          console.error('Falha ao assumir a ocorrência automaticamente:', assumeErr);
        }
        window.location.reload();
        return;
      }

      setLocalComments(prev => [...prev, {
        userName: localStorage.getItem('NameUser'),
        createdAt: new Date().toISOString(),
        description: commentSend,
      }]);

      refreshComments();

    } catch (err) {
      let errorMessage = 'Erro ao cadastrar o parecer, tente novamente.';

      if (err.message === 'Network Error') {
        errorMessage = 'Erro de conexão com o servidor. Verifique se o servidor está disponível.';
      } else if (err.response) {
        errorMessage = err.response.data?.error?.message || `Erro ${err.response.status}: ${err.response.statusText}`;
      }

      toast.error(errorMessage);
    }
  } // Registrar um parecer


  // chama o alerta para deletar 
  function notificationDeleteComment(commentId) {
    setConfirmDialog({
      isOpen: true,
      title: `Você gostaria de deletar o parecer ?`,
      subTitle: 'Esta ação não poderá ser desfeita',
      onConfirm: () => { deleteComment(commentId) }
    })
  }

  // Deletar parecer
  async function deleteComment(commentId) {
    try {
      await api.delete(`${userPermission}/coments/${commentId}`);

      setLocalComments(prev => prev.filter(c => c.id !== commentId));
      if (onCommentAdded) onCommentAdded();

      toast.success('Parecer deletado com sucesso.');
    } catch (err) {
      toast.error('Erro ao deletar o parecer, tente novamente.');

      // Fecha o dialog em caso de erro
      setConfirmDialog({ ...confirmDialog, isOpen: false });
    }
  }// Deletar parecer

  const formatNameFile = (name) => {
    if (name.length > 10)
      return name.substring(0, 10) + '...';
    return name;
  }

  function setCommentAndCache(comment) {
    const id_complaint = window.location.pathname.split("/").pop();
    localStorage.setItem(id_complaint + "_comment", comment);
    setCommentSend(comment)
  }

  async function setDocumentAndCache(doc) {

    const base64 = await toBase64(doc[0]);

    const id_complaint = window.location.pathname.split("/").pop();
    localStorage.setItem(id_complaint + "_document", base64);
    localStorage.setItem(id_complaint + "_document_name", doc[0].name);
    localStorage.setItem(id_complaint + "_document_type", doc[0].type);
    setDocumentBase64(base64)
    setDocumentName(doc[0].name)
    setDocumentType(doc[0].type)
  }

  useEffect(() => {
    const commentCache = localStorage.getItem(id_complaint + "_comment");
    if (commentCache) {
      setCommentSend(commentCache);
    }
    const documentCache = localStorage.getItem(id_complaint + "_document");
    if (documentCache) {
      setDocumentBase64(documentCache);
    }
    const documentCacheName = localStorage.getItem(id_complaint + "_document_name");
    if (documentCacheName) {
      setDocumentName(documentCacheName);
    }
    const documentCacheType = localStorage.getItem(id_complaint + "_document_type");
    if (documentCacheType) {
      setDocumentType(documentCacheType);
    }
  }, [id_complaint]);

  return (
    <>
      <Paper style={classes.paper} elevation={2}>
        <div style={classes.area} >
          <Typography
            variant="h6"
            align="left"
            style={{
              color: '#103168',
              fontWeight: 600,
              textAlign: 'center',
              marginBottom: 20
            }}
          >
            Parecer da Ocorrência
          </Typography>

          <Typography variant="body2" align="justify" style={classes.textDescription}>
            Abaixo é possível visualizar os comentários registrados
            pelos controladores e executores responsáveis pela resolução ocorrência.
          </Typography>

          <div>
            {localComments.filter(data => data.type !== 'cidadão').map(data => (
              <div key={data.id}>
                {data.type !== 'cidadão' ?
                  /* caso o usuário seja diferente de cidadão o seguinte codigo é renderizado */
                  <div style={classes.root}>
                    <SnackbarContent
                      sx={{
                        width: '100%', marginTop: '10px', backgroundColor: 'white', boxShadow: 'none',
                        '.MuiSnackbarContent-message': {
                          width: '100%'
                        }
                      }}
                      message={
                        <Grid
                          style={{ width: '100%' }}
                          container
                          justifyContent={'space-between'}
                        >
                          <Grid item >
                            <Typography style={classes.userComment}>
                              <b>{data.userName}</b> em {moment(data.createdAt).format('DD/MM/YYYY')} às {moment(data.createdAt).format('HH:mm')}:
                            </Typography>

                            <Typography variant="body2" align="justify" paragraph={true} style={classes.comment}>
                              <span>
                                {data.description}
                              </span>
                            </Typography>

                            {userPermission === 'admin' ?
                              <Typography variant="body2" align="justify" >
                                <IconButton
                                  aria-label="delete"
                                  color="secondary"
                                  onClick={() => { notificationDeleteComment(data.id) }}
                                >
                                  <DeleteIcon />
                                </IconButton>
                                Excluir parecer
                              </Typography>
                              : false}
                          </Grid>

                          {
                            data.documents && data.documents.length > 0 ?
                              <Grid item>
                                <div
                                  style={classes.downloadButton}
                                >
                                  <Link
                                    target='_blank'
                                    variant="outlined"
                                    href={data.documents[0].url}
                                  >
                                    <Download style={{ 'color': '#fff' }} />
                                  </Link>
                                </div>
                              </Grid> : false
                          }

                        </Grid>
                      }
                    />
                  </div>
                  :
                  /* caso o usuário seja igual a cidadão o seguinte codigo é renderizado */
                  <div style={classes.rootCidadao}>
                    <SnackbarContent style={{ marginTop: 10, backgroundColor: 'white', boxShadow: 'none' }} message={
                      <>
                        <Typography style={classes.userComment}>
                          {data.like === true ? <b>SOLUÇÃO APROVADA</b> : <b>SOLUÇÃO REPROVADA</b>} em {moment(data.createdAt).format('DD/MM/YYYY')} às {moment(data.createdAt).format('HH:mm')}:
                        </Typography>

                        <Typography variant="body2" align="justify" paragraph={true} style={classes.comment}>
                          <span>
                            {data.description}
                          </span>
                        </Typography>

                        {userPermission === 'admin' ?
                          <Typography variant="body2" align="justify" >
                            <IconButton
                              aria-label="delete"
                              color="secondary"
                              onClick={() => { notificationDeleteComment(data.id) }}
                            >
                              <DeleteIcon />
                            </IconButton>
                            Excluir parecer
                          </Typography>
                          : false}
                      </>
                    }
                    />
                  </div>
                }
              </div>
            ))}
          </div>

          {userPermission === "admin" ? true :
            <div className="complaint-coment">
              <Typography variant="body2" align="justify" style={classes.textDescription}>
                {`Digite abaixo um texto a respeito da ocorrência número ${cod_complaint}:`}
              </Typography>

              <form onSubmit={confirms} style={classes.areaDescription}>
                <textarea
                  placeholder="Digite o parecer técnico da ocorrência..."
                  value={commentSend}
                  onChange={e => setCommentAndCache(e.target.value)}
                />

                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'space-between'
                  }}
                >
                  <div style={{ width: 65 }} >
                  </div>

                  <Button
                    style={classes.buttonSubmit}
                    variant="outlined"
                    startIcon={<CommentIcon style={{ 'color': '#fff' }} />}
                    type="submit"
                  >
                    Realizar Parecer
                  </Button>

                  <Button
                    style={classes.attachButton}
                    variant="outlined"
                    onClick={(e) => fileInputRef.current.click()}
                  >
                    <AttachFile style={{ 'color': '#fff' }} />
                    {
                      documentBase64 && documentName ?
                        formatNameFile(documentName) : false
                    }
                  </Button>

                  <input
                    ref={fileInputRef}
                    style={{ display: 'none' }}
                    accept=".pdf"
                    type='file'
                    onChange={e => setDocumentAndCache(e.target.files)}
                  />
                </div>
              </form>
            </div>
          }
          <ConfirmDialog
            confirmDialog={confirmDialog}
            setConfirmDialog={setConfirmDialog}
          />
        </div >
      </Paper >
    </>
  );
}


